import script from "./WageBasicLoadNowEmp.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageBasicLoadNowEmp.vue?vue&type=script&setup=true&lang=ts"

import "./WageBasicLoadNowEmp.vue?vue&type=style&index=0&id=1290cdb6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1290cdb6"]])

export default __exports__